import { observable, action } from 'mobx';

export interface IConfig {
    [key: string]: string;
}
export class Config {
    @observable public config: IConfig = {};

    @action
    public updateConfig(config: IConfig) {
        this.config = { ...config };
    }
}
